<template>
  <div style="background: #fff;position: relative">
    <page-tab :tabs="tabs" :nowTab="nowTab"></page-tab>
    <div class="addAccount" @click="toAddJurisdiction()"><i class="yjh-icon icon-jurisdiction"></i>新增权限组</div>
    <page-table
      ref="table"
      v-loading="tableLoading"
      :loading="tableLoading"
      :col="tableCol"
      :data="tableData"
      :showPage="false"
      :pageSize="30"
      @compFn="compFn"
    ></page-table>
    <simple-diag
      :isShow="delDiag"
      :title="delTitle"
      :width="'400px'"
      :htm="false"
      @confirm="confirm"
      @close="toggleDelDiag(false)">
      <template>
        <div class="simple-diag-text">确定要删除权限组 <span class="blue">{{delName}}</span> 吗？删除后不可恢复</div>
      </template>
    </simple-diag>
  </div>
  </div>
</template>
<script>
import pageTab from '../../components/pageCom/pageTab'
import 'vue-easytable/libs/themes-base/index.css'
import { VTable } from 'vue-easytable'
import Vue from 'vue'
import pageTable from '../../components/pageCom/pageTable'
import simpleDiag from '@/components/dialogs/simpleDiag'
import { getJurisdictionList, getDelJurisdiction } from '@/api/app'
export default {
  name: 'jurisdiction-set',
  created() {
    this.$store.dispatch('setPage', { title: '账号权限', type: 'cover' })
  },
  props: [''],
  components: { pageTab, VTable, pageTable, simpleDiag },
  data() {
    return {
      tabs: [{
        text: '账号列表',
        linkName: 'accountList'
      }, {
        text: '权限组',
        linkName: 'jurisdictionSet'
      }],
      tableLoading: false, // 表格loading
      tableDataCount: 0, // 表格总数据
      tableCol: [], // 表格头数据
      tableData: [], // 表格数据
      delDiag: false, // 删除弹框
      delTitle: '删除提示',
      delName: '',
      adminId: '' // 管理员编号
    }
  },
  computed: {
    nowTab() {
      return this.$route.name
    }
  },
  methods: {
    // 删除账号确认
    confirm() {
      getDelJurisdiction({ gid: this.adminId }).then(res => {
        if (res.code === 0) {
          this.delDiag = false
          this.jurisdictionList()
        }
      })
    },
    // 删除弹框
    toggleDelDiag(flag) {
      this.delDiag = flag
    },
    // 表格内操作
    compFn(params) {
      this.delName = this.tableData[params.index].gname
      this.adminId = this.tableData[params.index].gid
      this.toggleDelDiag(true)
    },
    // 去新增页面
    toAddJurisdiction() {
      this.$router.push({ name: 'addJurisdiction' })
      // 如果进入了 新增 就本地存储一个值
      localStorage.setItem('isNull', 'true')
    },
    // 获取表格数据
    jurisdictionList() {
      this.tableLoading = true
      this.tableCol = [{
        field: 'custome-adv', title: '操作', width: 100, titleAlign: 'left', columnAlign: 'left', componentName: 'jurisdiction-operation', isResize: true
      }, {
        field: 'gname', title: '权限组', width: 260, titleAlign: 'left', columnAlign: 'left', isResize: true
      }]
      getJurisdictionList({ page: '1', per_page: '100' }).then(res => {
        if (res.code === 0) {
          this.tableLoading = false
          this.tableData = res.result.data
        }
      })
    }
  },
  mounted() {
    this.jurisdictionList()
  }
}
// 自定义列组件
Vue.component('jurisdiction-operation', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    // 编辑
    updateJurisdiction() {
      this.$router.push({
        name: 'editJurisdiction',
        query: {
          name: this.rowData['gname'],
          id: this.rowData['gid']
        }
      })
      // 如果进入了 编辑 就本地存储一个值
      localStorage.setItem('isNull', 'true')
    },
    // 删除
    deleteRowJurisdiction() {
      this.$emit('on-custom-comp', { index: this.index })
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.deleteRowJurisdiction
      }
    }, '删除'), h('a', {
      on: {
        click: this.updateJurisdiction
      }
    }, '编辑')])
  }
})
</script>
<style lang="scss">
  .addAccount {
    color: #5D6F80;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 0;
  }
</style>
